import jsBridge from './index'
/**
 * 进入H5页面后，用户需要返回至最后一个H5页面跳转至app页面，执行该方法
 */
export default function appBackLastPage() {
  return jsBridge('backLastPage')
}
